import React from "react";
import { Input, InputGroup, InputLeftElement, Spinner, Icon } from "@chakra-ui/react";
import { MdSearch } from "react-icons/md";

/**
 * Search input for filtering users by email or role.
 * Shows a spinner in the icon position while a search is in progress.
 * @param {object} props
 * @param {string} props.searchTerm - Current search value
 * @param {boolean} props.loading - Whether a search is in progress
 * @param {function} props.onSearch - Callback for input change events
 * @returns {React.ReactElement}
 */
function UsersSearchBar({ searchTerm, loading, onSearch }) {
    return (
        <InputGroup mb="16px" size="md">
            <InputLeftElement pointerEvents="none">
                {loading ? <Spinner size="sm" color="brand.500" /> : <Icon as={MdSearch} color="gray.400" />}
            </InputLeftElement>
            <Input value={searchTerm} onChange={onSearch} borderRadius="12px"
                placeholder="Rechercher un utilisateur, email..." />
        </InputGroup>
    );
}

export default UsersSearchBar;
